var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.svg.id)?_c('svg',{staticClass:"icon",class:{inline: this.inline}},[_c('use',{attrs:{"xlink:href":("#" + (_vm.svg.id))}})]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }